import React from 'react';
import '../less/guarantees.less';
import Banner from '../../../../../auxiliary-components/shared/Banner';
import banner_img from '../img/banner_img.png';
import usage_block_data from '../enums/usage_block_data.json';
import UsageBlock from '../../../../../auxiliary-components/shared/UsageBlock';
import FilesForDownload from '../../../../../auxiliary-components/shared/FilesForDownload/views/file.c'
import purpose_img from '../img/purpose_img.png'
import { getUrl } from 'utils/corploansUrl';

export default function template() {
    const isMobile = this.isViewportMobile();
    return (
        <div className='module-services'>
            <div className='guarantees-module'>
                <Banner
                    img={banner_img}
                    text={'GUARANTEES_BANNER_SUBTITLE'}
                    textMob={'GUARANTEES_BANNER_SUBTITLE_MOB'}
                    title={'GUARANTEES_BANNER_TITLE'}
                    toggleModal={() => window.open(getUrl('guarantee'))}
                    page={'guarantees'}
                    btnText={'SEND_APPLICATION'}
                    isMobile={isMobile}
                ></Banner>
                <div className='content'>
                    <div className='purpose-block'>
                        <div className='purpose-block-left-side'>
                            <h2 className='purpose-block-left-side-title' dangerouslySetInnerHTML={{__html: this.l10n('GUARANTEES_PURPOSE_TITLE')}}></h2>
                            <ul className='purpose-block-left-side-list'>
                                <li className='purpose-block-left-side-list-item' dangerouslySetInnerHTML={{__html: this.l10n('GUARANTEES_PURPOSE_TEXT_1')}}></li>
                                <li className='purpose-block-left-side-list-item' dangerouslySetInnerHTML={{__html: this.l10n('GUARANTEES_PURPOSE_TEXT_2')}}></li>
                                <li className='purpose-block-left-side-list-item' dangerouslySetInnerHTML={{__html: this.l10n('GUARANTEES_PURPOSE_TEXT_3')}}></li>
                                <li className='purpose-block-left-side-list-item' dangerouslySetInnerHTML={{__html: this.l10n('GUARANTEES_PURPOSE_TEXT_4')}}></li>
                            </ul>
                            <button className='purpose-block-left-side-button' onClick={() => window.open(getUrl('guarantee'))}>{this.l10n('SEND_APPLICATION')}</button>
                        </div>
                        <div className='purpose-block-right-side'>
                            <img src={purpose_img} alt="purpose_img" className='purpose-block-right-side-img' />
                        </div>
                    </div>
                    <UsageBlock
                        isMobile={isMobile}
                        page={'salary-project'}
                        data={usage_block_data}
                        className='col-2-row-2'
                    ></UsageBlock>

                    <FilesForDownload style={{marginBottom: 0}} lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}/>

                    </div>
            </div>
        </div>
    );
}
